module.exports = __webpack_public_path__ + "img/yz.2346dfbe.png";